import React from 'react';
import { Line } from 'react-chartjs-2';
import { compose, withStateHandlers, StateHandlerMap } from 'recompose';
import './ChatBlastReportStatisticsGraph.scss';

type OuterProps = {
  responded: {
    [key: number]: number;
  };
  read: {
    [key: number]: number;
  };
  smsResponded: {
    [key: number]: number;
  };
  isSMS?: boolean;
  isFacebook?: boolean;
};

type DataSet = {
  label: string;
  fill: false;
  lineTension: number;
  backgroundColor: string;
  borderColor: string;
  borderCapStyle: string;
  borderDash: [];
  borderDashOffset: number;
  borderJoinStyle: string;
  pointBorderColor: string;
  pointBackgroundColor: string;
  pointBorderWidth: number;
  pointHoverRadius: number;
  pointHoverBackgroundColor: string;
  pointHoverBorderColor: string;
  pointHoverBorderWidth: number;
  pointRadius: number;
  pointHitRadius: number;
  data: number[];
};

type StateProps = {
  data: {
    labels: string[];
    datasets: DataSet[];
  };
  legend: {
    [key: string]: any;
  };
};

type StateHandlerProps = StateHandlerMap<StateProps> & {
  setOpenedData(value: any): void;
  setReadData(value: any): void;
};

type InnerProps = StateProps & StateHandlerProps;

type Props = OuterProps & InnerProps;

const initialState = (props: OuterProps) => {
  const { responded, read, smsResponded, isSMS, isFacebook } = props;
  const respondedValues = Object.keys(responded).map(key => responded[key]);
  const readValues = Object.keys(read).map(key => read[key]);
  const smsRespondedValues = Object.keys(smsResponded).map(key => read[key]);
  const fbDataSet = [
    {
      label: 'Messenger Reads',
      fill: false,
      lineTension: 0.03,
      backgroundColor: '#3952FA',
      borderColor: '#3952FA',
      borderCapStyle: 'butt',
      borderDash: [],
      borderDashOffset: 0.0,
      borderJoinStyle: 'miter',
      pointBorderColor: '#3952FA',
      pointBackgroundColor: '#fff',
      pointBorderWidth: 1,
      pointHoverRadius: 5,
      pointHoverBackgroundColor: '#3952FA',
      pointHoverBorderColor: '#3952FA',
      pointHoverBorderWidth: 2,
      pointRadius: 1,
      pointHitRadius: 10,
      data: [0, ...readValues],
    },
    {
      label: 'Messenger Responses',
      fill: false,
      lineTension: 0.03,
      backgroundColor: '#7BB6E4',
      borderColor: '#7BB6E4',
      borderCapStyle: 'butt',
      borderDash: [],
      borderDashOffset: 0.0,
      borderJoinStyle: 'miter',
      pointBorderColor: '#7BB6E4',
      pointBackgroundColor: '#fff',
      pointBorderWidth: 1,
      pointHoverRadius: 5,
      pointHoverBackgroundColor: '#7BB6E4',
      pointHoverBorderColor: '#7BB6E4',
      pointHoverBorderWidth: 2,
      pointRadius: 1,
      pointHitRadius: 10,
      data: [0, ...respondedValues],
    },
  ];
  const smsDataSet = [
    {
      label: 'SMS Responses',
      fill: false,
      lineTension: 0.03,
      backgroundColor: '#9786FF',
      borderColor: '#9786FF',
      borderCapStyle: 'butt',
      borderDash: [],
      borderDashOffset: 0.0,
      borderJoinStyle: 'miter',
      pointBorderColor: '#9786FF',
      pointBackgroundColor: '#fff',
      pointBorderWidth: 1,
      pointHoverRadius: 5,
      pointHoverBackgroundColor: '#9786FF',
      pointHoverBorderColor: '#9786FF',
      pointHoverBorderWidth: 2,
      pointRadius: 1,
      pointHitRadius: 10,
      data: [0, ...smsRespondedValues],
    },
  ];
  const data = {
    labels: ['00:00', '04:00', '08:00', '12:00', '16:00', '20:00', '24:00'],
    datasets: [] as any,
  };

  if (isFacebook) {
    data.datasets = [...data.datasets, ...fbDataSet];
  }

  if (isSMS) {
    data.datasets = [...data.datasets, ...smsDataSet];
  }

  const legend = {
    position: 'top',
  };

  return {
    data,
    legend,
  };
};

const stateUpdaters = {};

const enhance = compose<InnerProps, OuterProps>(
  withStateHandlers(initialState, stateUpdaters),
);

const ChatBlastReportStatisticsGraph = ({ data, legend, options }: Props) => (
  <div className="blast-report-graph">
    <h2 className="blast-report-graph__header">First 24 hours</h2>
    <Line data={data} legend={legend} options={options} />
  </div>
);

export default enhance(ChatBlastReportStatisticsGraph);
